import Vue from 'vue';
import Vuex from 'vuex';
import {register as registerAnnotation} from './features/annotation';
import {register as registerAudioConference} from './features/audioConference';
import {register as registerKinematics} from './features/kinematics';
import {register as registerOnBoardTutorial} from './features/onBoardTutorial/index';
import {register as registerGarbageCan} from './features/garbage-can';
import {register as registerTraining} from './features/training';
import {register as registerNotificationManager} from './features/notificationManager'
import {register as registerVolumeData} from './features/model/volume-store';

Vue.use(Vuex);

let store = new Vuex.Store({});

registerAnnotation(store);
registerGarbageCan(store);
registerAudioConference(store);
registerKinematics(store);
registerOnBoardTutorial(store);
registerTraining(store);
registerVolumeData(store);
registerNotificationManager(store);

export default store;
